import { JSON_CONTENT } from '@src/utils/ajaxUtils'
import authAjax from '@user/utils/ajaxUtils'

const API_PATH = '/user'

export const getAjax = (id: string) =>
  authAjax.get(`${API_PATH}/${id}`, JSON_CONTENT)
